__turbopack_context__.v({
  "groupLabel": "GroupLabel-module__0iiXvG__groupLabel",
});
